class PropsFn {
  constructor() {}
  /**
   * 判断值val为是否为空
   * @param {*} val
   */
  hasValue(val) {
    if (val === null || val === undefined || val === '') {
      return false
    } else {
      return true
    }
  }
  /**
   * 判断值val为空时，返回默认想展示的内容defaultVal || --
   * @param {*} val
   * @param {*} defaultVal
   */
  safeDislayValue(val, defaultVal) {
    if (this.hasValue(val)) {
      return val
    } else {
      return defaultVal || '--'
    }
  }
}
export default new PropsFn()
